import React, { useRef }  from 'react';
import { useHistory } from 'react-router-dom';
import logo from './images/image001.png';
import profile from './images/ProfileLogo.svg';
import { Menu } from 'primereact/menu';
import { useStoreActions, useStoreState } from 'easy-peasy';
import AmphenolLogo from './images/updatedLogosmallsize.svg';
import DownArrow from './images/ArrowDown.svg';

export const AppTopbar = (props) => {
    const menu = useRef(null);
    let history = useHistory();
    const setLogOut = useStoreActions((actions) => actions.loginModel.setLogOut);
    const setLoginDetails = useStoreActions((actions) => actions.projectModel.setLoginDetails);
    const loginDetails = useStoreState((actions) => actions.projectModel.loginDetails);
    const setRoleDetails = useStoreActions((actions) => actions.projectModel.setRoleDetails);
    const roleDetails = useStoreState((actions) => actions.projectModel.roleDetails);
    const setEmployeeName = useStoreActions((actions) => actions.projectModel.setEmployeeName);
    const employeeName = useStoreState((actions) => actions.projectModel.employeeName);
   

    let items = [
        {
            label: "Logout",
            icon: 'pi pi-fw pi-power-off',
            command: () => {
                history.replace("/");
                setLogOut(null)
            },
        },
    ];

    return (
        <div className="layout-topbar">
        <Menu model={items} popup ref={menu} />
            {/* <span className='layout-menu-button'><img src={logo} className='surface-900' alt='logo' /></span> */}
            <button type="button" className="p-link layout-menu-button layout-topbar-button" onClick={props.onToggleMenuClick} >
                <i className="pi pi-bars"/>
            </button>
            <div className='flex justify-content-between align-items-center' style={{ width: '100%' }} >
                <div className= "flex justify-content-left align-items-left text-left"> <img className="AmphenolLogo hidden md:block" src={AmphenolLogo} style={{ width: "185px" , height: "61px", objectFit: "cover"}}/> </div>
                <div className='flex align-items-center' onClick={(e) => menu.current.toggle(e)} style={{cursor:'pointer'}}> 
                    <div className="logo-link ms-sm-5 hover_cursor flex align-items-center">
                        <img className="rightLogo" height="35" width="35" src={profile} />
                    </div>
                    <div className='mx-2'>
                        <div className='group-project-name'>{employeeName}</div><div className='role_detail'>{roleDetails}</div>
                    </div>
                    <div>
                    <img src={DownArrow}  />
                    </div>
                </div>
            </div>

            {/* <button type="button" style={{ visibility: "hidden" }} className="p-link layout-topbar-menu-button layout-topbar-button" onClick={props.onMobileTopbarMenuClick}>
            </button> */}
        </div>
    );
}
